import { create } from "zustand";

/* * This store manages the state of the join session in the app. */
interface JoinState {
  teamName: string;
  setTeamName: (teamName: string) => void;
  invitingUserName: string;
  setInvitingUserName: (invitingUserName: string) => void;
  invitingUserHeadshotUrl?: string | undefined;
  setInvitingUserHeadshotUrl: (
    invitingUserHeadshotUrl: string | undefined,
  ) => void;
  teamProfilePictureUrl?: string | undefined;
  setTeamProfilePictureUrl: (teamProfilePictureUrl: string | undefined) => void;
  userCount: number;
  setUserCount: (userCount: number) => void;
  code: string;
  setCode: (code: string) => void;
}

export const useJoinState = create<JoinState>((set) => ({
  teamName: "",
  setTeamName: (teamName) => {
    set({ teamName });
  },
  invitingUserName: "",
  setInvitingUserName: (invitingUserName) => {
    set({ invitingUserName });
  },
  invitingUserHeadshotUrl: undefined,
  setInvitingUserHeadshotUrl: (invitingUserHeadshotUrl: string | undefined) => {
    set({ invitingUserHeadshotUrl });
  },
  teamProfilePictureUrl: undefined,
  setTeamProfilePictureUrl: (teamProfilePictureUrl: string | undefined) => {
    set({ teamProfilePictureUrl });
  },
  userCount: 0,
  setUserCount: (userCount) => {
    set({ userCount });
  },
  code: "",
  setCode: (code) => {
    set({ code });
  },
}));
